.logo {
    width: 2rem;
}
